var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 40C10.5 43.9397 11.276 47.8407 12.7836 51.4805C14.2913 55.1203 16.501 58.4274 19.2868 61.2132C22.0726 63.999 25.3797 66.2087 29.0195 67.7164C32.6593 69.224 36.5603 70 40.5 70C44.4397 70 48.3407 69.224 51.9805 67.7164C55.6203 66.2087 58.9274 63.999 61.7132 61.2132C64.499 58.4274 66.7087 55.1203 68.2164 51.4805C69.724 47.8407 70.5 43.9397 70.5 40C70.5 36.0603 69.724 32.1593 68.2164 28.5195C66.7087 24.8797 64.499 21.5726 61.7132 18.7868C58.9274 16.001 55.6203 13.7913 51.9805 12.2836C48.3407 10.776 44.4397 10 40.5 10C36.5603 10 32.6593 10.776 29.0195 12.2836C25.3797 13.7913 22.0726 16.001 19.2868 18.7868C16.501 21.5726 14.2913 24.8797 12.7836 28.5195C11.276 32.1593 10.5 36.0603 10.5 40Z",
    stroke: "#F6CA4A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8333 30C49.2295 28.9525 48.3522 28.089 47.2953 27.5018C46.2384 26.9146 45.0417 26.6259 43.8333 26.6666H37.1667C35.3986 26.6666 33.7029 27.369 32.4526 28.6192C31.2024 29.8695 30.5 31.5652 30.5 33.3333C30.5 35.1014 31.2024 36.7971 32.4526 38.0473C33.7029 39.2976 35.3986 40 37.1667 40H43.8333C45.6014 40 47.2971 40.7023 48.5474 41.9526C49.7976 43.2028 50.5 44.8985 50.5 46.6666C50.5 48.4347 49.7976 50.1304 48.5474 51.3807C47.2971 52.6309 45.6014 53.3333 43.8333 53.3333H37.1667C35.9583 53.374 34.7616 53.0853 33.7047 52.4981C32.6478 51.9109 31.7705 51.0474 31.1667 50",
    stroke: "#F6CA4A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 23.3333V56.6666",
    stroke: "#F6CA4A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.c65f2e7faffc7f30ee04c3e0696b3e41.svg";
export { ForwardRef as ReactComponent };